import { z } from 'zod';

export const notificationEvent = <E extends string, M extends z.ZodType>(event: E, metadata: M) =>
  z.object({
    type: z.literal('notification'),
    event: z.literal(event),
    metadata,
  });
